import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router";

import { NavButton, SimpleContainer } from "./styled/simpleTheme";

import SimpleBanner from "./themes/simple/banner";
import Products from "./themes/simple/products";
import AutoScrolling from "./themes/simple/autoScrolling";
import BoxStack from "./themes/simple/boxStack";
import axios from "axios";
import SmProducts from "./themes/simple/smProducts";

const DEFAULT_PRODUCTS = Array.from({ length: 4 }, (_, idx) => ({
  name: "상품",
  media: "/img/shop_network.png",
}));

const SimpleTheme = ({ homepageInfo }) => {
  const navigate = useNavigate();
  const { cmpnyNo, url } = useOutletContext();

  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (cmpnyNo) {
      getProducts(cmpnyNo);
    }
  }, [cmpnyNo]);

  const getProducts = async (cmpnyNo) => {
    try {
      const url = "/erp/vendorProducts/get";
      const query = `
      query VendorProducts(
        $cmpnyNo: Int!
        $limit: Int
        $offset: Int
      ) {
        vendorProducts(
          filter: {
            cmpnyNo: $cmpnyNo
            limit: $limit
            offset: $offset
          }
        ) {
          totalCount
          products {
            id
            name
            media
            price
          }
        }
      }
    `;
      const variables = {
        cmpnyNo: parseInt(cmpnyNo, 10),
        limit: 8,
        offset: 0,
      };
      const body = { query, variables };

      const res = await axios.post(url, body);
      if (res.status === 200) {
        const products = res?.data?.products || [];

        setProducts(products.length > 0 ? products : DEFAULT_PRODUCTS);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <SimpleContainer>
      <SimpleBanner />
      {cmpnyNo === 15922 && <AutoScrolling />}
      <Products products={products} homepageInfo={homepageInfo} />
      <BoxStack products={products} />
      <SmProducts products={products} />
      {/* {cmpnyNo === 15922 && ( */}
      <NavButton>
        <button
          onClick={() =>
            navigate(`/shop/${url}/shoppingNotice?page=0`, { state: { tabIndex: 1 } })
          }>
          문의하기
        </button>
      </NavButton>
      {/* )} */}
    </SimpleContainer>
  );
};

export default SimpleTheme;
